// Module
var code = `<installs-table
    prec="2"
    rows="rows"
    tooltips="tooltips"
    column_names="column_names"
>
</installs-table>
`;
// Exports
module.exports = code;